"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicAnalyses = void 0;
var models_1 = require("@livv/models");
/** Returns published and validated analyses */
var getPublicAnalyses = function (analyses) {
    return analyses.filter(function (_a) {
        var isPublished = _a.isPublished, validationStatus = _a.validationStatus;
        return isPublished && validationStatus === models_1.VALIDATION_STATUSES.VALIDATED;
    });
};
exports.getPublicAnalyses = getPublicAnalyses;
//# sourceMappingURL=analyses.js.map